import { updateUrlHash } from "~/components/plp-page/helpers";
import { DEFAULT_PAGE_SIZE as DEFAULT_PRODUCTS_PAGE_SIZE } from "~/components/products-layout/constants";
import { removePageFromUrl } from "~/helpers/use-remove-page-from-url/helper";
import { IUseRequestHandlerActionsKind } from "~/types/products-request-handler";

import { ISortingParamsHandler } from "../types";

export const onActiveSortingParamSet = async ({
  q,
  efq,
  brUid2,
  brRefUrl,
  searchParams,
  pathname,
  locale,
  productType,
  sortingParameter,
  getMoreItems,
  dispatchRequest,
  appliedFilters,
  isShopFilter,
  currentStore,
  pageNumber,
  productsMarkerId,
  setProductsMarkerId,
}: ISortingParamsHandler): Promise<void> => {
  if (productsMarkerId) {
    setProductsMarkerId(null);
  }
  pageNumber.current = 1;

  dispatchRequest({
    type: IUseRequestHandlerActionsKind.UPDATE_SORTING,
    payload: {
      sortingParam: sortingParameter,
      updateFunc: updateUrlHash,
      params: {
        productType,
        isShopFilter,
        appliedFilters,
        activeSortingParam: sortingParameter,
        selectedStoreId: currentStore?.id,
        config: {
          pageNumber: pageNumber.current,
          getMoreItems,
          variables: {
            rows: DEFAULT_PRODUCTS_PAGE_SIZE,
            start: 0,
            efq,
            q,
            locale,
            brUid2,
            brRefUrl,
          },
        },
      },
    },
  });
  removePageFromUrl(searchParams, pathname);
};
